import React, {useEffect, useState, useRef, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import APICallExternal from "../../../../../../../../../../artibulles-cis/utils/APICallExternal";
import Button from "@artibulles-cis/react/Button";
import LocalCircularLoader from "@artibulles-cis/react/LocalCircularLoader";
import {toast} from "react-toastify";
import CardModal from "@artibulles-cis/react/CardModal";
import TabNavContent from "@artibulles-cis/react/TabNavContent";
import AGGridTable from "../../../../../../../../../../artibulles-cis/AGGridTable/AGGridTable";
import InvoiceItemsEdit from "./InvoiceItemsEdit";
import InvoiceDuplicate from "./InvoiceDuplicate";

import {AddCircle, PDF} from "@artibulles-cis/react-icons";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    FormField: {
        flex: "0 1 600px",
        margin: "5px 10px 5px 10px",
    },
    TableWrapper: {
        position: "relative",
        boxSizing: "border-box",
        padding: "5px 0px",
        display: "flex",
        width: "100%",
        // maxWidth: "1200px",
        // maxHeight: "800px",
        height: "250px",
        margin: "0 auto",
        justifyContent: "center",
    },
    ClassExtendTabContent: {
        padding: "0px 5px 0px 5px",
        boxSizing: "border-box",
        // maxWidth: "1200px",
    },
    CardTitle: {
        display: "flex",
        justifyContent: "center",
        color: "white",
        fontWeight: "600",
        boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        background: "rgb(255,97,3)",
        flex: "0 0 35px",
    },
    ButtonBar: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
    },
    ButtonLeft: {
        flex: " 1 1 auto",
        display: "flex",
    },
    ButtonMiddle: {
        flex: " 1 1 auto",
        display: "flex",
    },
    ButtonRight: {
        flex: " 1 1 auto",
        display: "flex",
        justifyContent: "flex-end",
    },
    CardContent: {
        color: "black",
        height: "100%",
        overflow: "hidden",
    },
    ClassExtendCardNoScroll: {
        overflow: "hidden",
    },
}));

const CustomerEditBankAccountTable = React.memo(function CustomerEditBankAccountTable(props) {
    const {FormViewMode, SaleInvoiceID, SubmitParentForm, PDFUploadedUpdate, FormValues, FieldOptionsParent, CustomerAccountingPreference} = props;
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/
    const Ref_LocaleData = useRef();
    const Ref_PurchaseItemViewMode = useRef();
    /***************** REFS ******************/

    /***************** CONST ******************/
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-bms.artibulles.com";

    const HandleDeleteRow = (Id) => {
        // console.log("HandleDeleteRow", Id);
        if (Id) {
            const ApiCall = {url: `${ProdURL}/api/saleinvoices/invoicegeneration/invoiceitems/invoiceitem/${Id}`, type: "delete"};
            setLoading(true);
            setAPICallType("deleteone");

            async function APIInternal() {
                const res = await APICallExternal(ApiCall);
                setApiRes(res);
                setLoading(false);
            }

            APIInternal();
        }
    };
    const HandleEditRow = (Id, RowData) => {
        setShowEditPuchaseItemCard(true);
        setViewCartPurchaseItemId(Id);
        // setPurchaseItemViewMode("Edit");
        Ref_PurchaseItemViewMode.current = "Edit";
    };

    const HandleViewRow = (Id, RowData) => {
        // setPurchaseItemViewMode("View");
        Ref_PurchaseItemViewMode.current = "View";
        setShowEditPuchaseItemCard(true);
        setViewCartPurchaseItemId(Id);
    };

    const HandleDuplicateInvoiceItem = (Id, RowData) => {
        setDuplicateCardId(Id);
        setShowDuplicateCard(true);
    };
    const TableColumns = [
        {
            field: "InvoiceLineIndex",
            headerName: "#",
            headerClass: "ag-CenterHeader",
            // flex: 1,
            width: 50,
            // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 1,
            // sortingOrder: ["asc", "desc"],
            // Type: "Date",
        },
        {
            field: "ArticleName",
            headerName: "ArticleName",
            headerClass: "ag-CenterHeader",
            flex: 1,
            minWidth: 200,
            autoHeight: true,
            wrapText: true,
            // width: 150,
            // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "desc",
            // sortIndex: 1,
            // sortingOrder: ["asc", "desc"],
            // Type: "Date",
        },

        {
            field: "UnitPriceVATExcluded",
            //
            headerName: "Unit Price",
            headerClass: "ag-CenterHeader",
            width: 105,
            Type: "Currency",
            // filter: true,
            // sortingOrder: ["asc", "desc"],
            // Type: "Boolean",
        },
        {
            field: "Quantity",
            //
            headerName: "Quantity",
            headerClass: "ag-CenterHeader",
            width: 90,
            // filter: true,
            // sortingOrder: ["asc", "desc"],
            // cellRenderering: PaymentActionRendering,
            // cellStyle: PaymentCell,
        },
        {
            field: "CalcTotalVATExcluded",
            headerName: "Total",
            headerClass: "ag-CenterHeader",
            width: 105,
            Type: "Currency",
            // filter: "agNumberColumnFilter",
            // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            //
            // TotalRow: {
            //     Show: true,
            //     // Rendering: (params) => {
            //     //     return <div>Coucou</div>;
            //     // },
            // },
        },
        // {
        //     field: "TaxCode.TaxName",
        //     headerName: "Taxes",
        //     headerClass: "ag-CenterHeader",
        //     width: 85,
        //     // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
        //     // sortingOrder: ["asc", "desc"],
        //     // Type: "Date",
        // },

        {
            field: "CalcVATAmount",
            headerName: "VAT",
            headerClass: "ag-CenterHeader",
            width: 95,
            Type: "Currency",
            // filter: "agNumberColumnFilter",
            // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},

            // TotalRow: {
            //     Show: true,
            //     // Rendering: (params) => {
            //     //     return <div>Coucou</div>;
            //     // },
            // },
        },
        {
            field: "CalcTotalVATIncluded",
            headerName: "Tot VAT",
            headerClass: "ag-CenterHeader",
            width: 105,
            Type: "Currency",
            // filter: "agNumberColumnFilter",
            // filterParams: {buttons: ["apply", "reset"], closeOnApply: true},

            // TotalRow: {
            //     Show: true,
            //     // Rendering: (params) => {
            //     //     return <div>Coucou</div>;
            //     // },
            // },
        },
    ];

    const HandleUpdateRows = (ToReorder) => {
        console.log("rows", ToReorder);
        let DataForm = {
            SaleInvoiceID: SaleInvoiceID,
            ToReorder: ToReorder,
        };
        //We need to push to update all the rows and change the indexes;
        const ApiCall = {url: `${ProdURL}/api/saleinvoices/invoicegeneration/invoiceitems/reorder`, type: "post", data: DataForm};
        setLoading(true);
        setAPICallType("Reorder");

        async function APIInternal() {
            const res = await APICallExternal(ApiCall);
            setApiRes(res);
            setLoading(false);
        }

        APIInternal();
    };
    const TableOptions = {
        // Selection: {
        //     // Multiple: true,
        //     WithCheckBox: true,
        // },
        RowDragUpdateServer: HandleUpdateRows,
        RowDragging: true,
        Resizable: true,
        Sortable: true,
        Filterable: true,
        SupressMenu: true,
        WrapText: true,
        WrapHeader: false,
        HeaderHeight: 30,
        RowHeight: 24,
        RowFontSize: "13px",
        HeaderFontSize: "14px",
        StatusBar: true,
    };
    // const TotalRow = {
    //     Position: "Bottom",
    //     Style: null,
    // };

    /***************** CONST ******************/

    /***************** STATE ******************/

    const [Init, setInit] = useState(false);
    const [CreateNewOnly, setCreateNewOnly] = useState(false);

    const [APICallType, setAPICallType] = useState(null);
    const [ShowEditPuchaseItemCard, setShowEditPuchaseItemCard] = useState(false);
    const [ViewCartPurchaseItemId, setViewCartPurchaseItemId] = useState(null);
    const [PurchaseItemViewMode, setPurchaseItemViewMode] = useState(null);
    const [ApiRes, setApiRes] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [TableComponent, setTableComponent] = useState(null);

    const [ShowDuplicateCard, setShowDuplicateCard] = useState(false);
    const [DuplicateCardId, setDuplicateCardId] = useState(null);
    const [ReloadTableData, setReloadTableData] = useState(true);
    /***************** STATE ******************/

    /***************** CALLBACK ******************/
    const EndofAPI = useCallback(() => {
        //Making sure the Loading is done and the Results are ready

        if (!Loading && ApiRes) {
            if (ApiRes.error) {
                // console.log("error", ApiRes);
            } else {
                if (APICallType === null) {
                    if (ApiRes && ApiRes.data && ApiRes.data.data) {
                        let Data = ApiRes.data.data;
                        // console.log("PurchaseInvoiceItems", Data);

                        // console.log("not init");

                        if (Data.SaleInvoiceItems && Array.isArray(Data.SaleInvoiceItems) && Data.SaleInvoiceItems.length > 0) {
                            Ref_LocaleData.current = Data;
                            setInit(true);
                            setTimeout(() => {
                                SubmitParentForm(Ref_LocaleData.current);
                            }, 200);
                            setReloadTableData(false);
                        } else {
                            Ref_LocaleData.current = null;
                            // console.log("New ONly");
                            setCreateNewOnly(true);
                            setInit(true);
                            setTimeout(() => {
                                SubmitParentForm(Ref_LocaleData.current);
                            }, 200);
                        }
                    }
                } else {
                    if (APICallType === "deleteone") {
                        toast.success(`Entry deleted`, {autoClose: true});

                        Ref_LocaleData.current = null;
                        setAPICallType(null);
                        setTimeout(() => {
                            setInit(false);
                        }, 50);
                        // setTimeout(() => {
                        //     SubmitParentForm();
                        // }, 200);
                    }
                    if (APICallType === "Reorder") {
                        if (ApiRes && ApiRes.data && ApiRes.data.data) {
                            let Data = ApiRes.data.data;
                            console.log("Reorder");
                            setAPICallType(null);

                            if (Data.SaleInvoiceItems && Array.isArray(Data.SaleInvoiceItems) && Data.SaleInvoiceItems.length > 0) {
                                Ref_LocaleData.current = Data;
                            }

                            // Ref_LocaleData.current = null;
                            // setAPICallType(null);
                        }
                    }
                    if (APICallType === "GeneratePDF") {
                        console.log("Generate PDF");
                        //We need to force the Update of the ParentComponent
                        PDFUploadedUpdate();
                    }
                }
            }
        }
    }, [ApiRes, Loading]);

    const GenerateTableComponent = useCallback(() => {
        setTableComponent(null);
        let FinalTableComponent = null;

        if (Ref_LocaleData.current) {
            let TableRowButtons;
            if (FormViewMode === "View") {
                let ColumnButtonStyle = {
                    Width: 75,
                    padding: "0px 0px 0px 0px",
                };
                TableRowButtons = [
                    {
                        Standard: true,
                        Name: "View",
                        ActiveCondition: null,
                        Index: 1,
                        OnClick: HandleViewRow,
                        // IconSize: "10px",
                        // ActiveColor: "red",
                        // HoverColor: "green",
                        // InactiveColor: "blue",
                        Tooltip: {Show: true, Position: "right", Theme: "light"},
                    },
                ];
                FinalTableComponent = (
                    <AGGridTable
                        TableName="InvoiceitemsTable_ViewMode"
                        Data={Ref_LocaleData.current}
                        // URLAbsolute={URLAbsolute}
                        TableColumns={TableColumns}
                        MainDataSource="SaleInvoiceItems"
                        RowActionButtons={TableRowButtons}
                        ColumnButtonStyle={ColumnButtonStyle}
                        TableOptions={TableOptions}
                        // ReloadData={ReloadTableData}
                        // SyncReloadDataStateFunction={setReloadTableData}
                        // TotalRow={TotalRow}
                    />
                );
            } else {
                let ColumnButtonStyle = {
                    Width: 120,
                    padding: "0px 0px 0px 0px",
                };
                TableRowButtons = [
                    {
                        Standard: true,
                        Name: "Edit",
                        ActiveCondition: null,
                        Index: 1,
                        OnClick: HandleEditRow,
                        // IconSize: "10px",
                        // ActiveColor: "red",
                        // HoverColor: "green",
                        // InactiveColor: "blue",
                        Tooltip: {Show: true, Position: "right", Theme: "light"},
                    },
                    {
                        Standard: true,
                        Name: "Duplicate",
                        ActiveCondition: null,
                        Index: 2,
                        OnClick: HandleDuplicateInvoiceItem,
                        Tooltip: {Show: true, Position: "right", Theme: "light"},
                    },

                    {
                        Standard: true,
                        Name: "Delete",
                        // ActiveCondition: DeleteCondition,
                        Index: 2,
                        OnClick: HandleDeleteRow,
                        ConfirmationMessage: true,
                        // IconSize: "10px",
                        // ActiveColor: "red",
                        // HoverColor: "green",
                        // InactiveColor: "blue",
                        Tooltip: {Show: true, Position: "right", Theme: "light"},
                    },
                ];
                FinalTableComponent = (
                    <AGGridTable
                        TableName="InvoiceitemsTable_EditMode"
                        Data={Ref_LocaleData.current}
                        // URLAbsolute={URLAbsolute}
                        TableColumns={TableColumns}
                        MainDataSource="SaleInvoiceItems"
                        RowActionButtons={TableRowButtons}
                        ColumnButtonStyle={ColumnButtonStyle}
                        TableOptions={TableOptions}
                        // ReloadData={ReloadTableData}
                        // SyncReloadDataStateFunction={setReloadTableData}
                        // TotalRow={TotalRow}
                    />
                );
            }
        }

        setTimeout(() => {
            setTableComponent(FinalTableComponent);
            setReloadTableData(false);
        }, 200);
    }, [Ref_LocaleData.current, Init, FormViewMode]);
    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    useEffect(() => {
        Ref_PurchaseItemViewMode.current = FormViewMode;
    }, []);
    useEffect(() => {
        // if (ReloadTableData === true) {
        if (Init === false || ReloadTableData === true) {
            console.log("Reloading Table");
            const ApiCall = {url: `${ProdURL}/api/saleinvoices/invoicegeneration/invoiceitems/invoiceitems/${SaleInvoiceID}`, type: "get"};
            setLoading(true);
            setAPICallType(null);

            async function APIInternal() {
                const res = await APICallExternal(ApiCall);
                setApiRes(res);
                setLoading(false);
            }

            APIInternal();
        }
    }, [Init, ReloadTableData]);

    useEffect(() => {
        //Used to prevent executing the core function multiple times
        if (!Loading && ApiRes) {
            EndofAPI();
        }
    }, [Loading, ApiRes]);

    useEffect(() => {
        if (Init === true && CreateNewOnly === false) {
            GenerateTableComponent();
        }
    }, [GenerateTableComponent, Init, FormViewMode, ReloadTableData, CreateNewOnly]);

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    const HandleCloseEditItemCard = () => {
		console.log("HandleCloseEditCard", FormViewMode)
        // console.log("", PurchaseItemViewMode);
        if (FormViewMode === "Edit") {
            //We refresh the parent form to recalculate the invoice amount
            // console.log("InvoiceItemsTable, Edit");
            setCreateNewOnly(false);
            setTimeout(() => {
                setInit(false);
            //     setReloadTableData(true);
            }, 50);

            setTimeout(() => {
                SubmitParentForm();
            }, 200);
        }
        setShowEditPuchaseItemCard(false);
        setViewCartPurchaseItemId(null);
    };

    const HanldeCreateNewPurcahseItem = () => {
        setShowEditPuchaseItemCard(true);
        setViewCartPurchaseItemId("new");
    };

    const HandleGenerateInvoice = () => {
        let DataForm = {};
        const ApiCall = {url: `${ProdURL}/api/saleinvoices/invoicegeneration/generatepdf/${SaleInvoiceID}`, type: "post", data: DataForm};
        setLoading(true);
        setAPICallType("GeneratePDF");

        async function APIInternal() {
            const res = await APICallExternal(ApiCall);
            setApiRes(res);
            setLoading(false);
        }

        APIInternal();
    };
    const HandleCloseDuplicateCard = (Id) => {
        // console.log("Should close the card")
        setShowDuplicateCard(false);
        setDuplicateCardId(null);

        setTimeout(() => {
            setReloadTableData(true);
        }, 300);
    };
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/
    var ModalCard;
    if (ShowEditPuchaseItemCard === true) {
        ModalCard = (
            <CardModal
                CardID="PurchaseItemCard"
                // ParentCompRef={Ref_TabNavContent}
                TopBarContent={<div>Sale Invoice Item</div>}
                ClassExtendTopToolBar={classes.CardTitle}
                CloseCard={HandleCloseEditItemCard}
                CloseOnClickOutside={false}
                WithCloseButton={true}
                CardMaxWidth="900px"
                CardHeight="500px"
                // CardWindowPaddingVertical="10px"
                // CardWindowPaddingHorizontal="10px"
                WithPerfectScrollbar={true}
                // CardWindowPaddingVertical="50px"

                ShowCard={true}
                WindowBackgroundColor="rgba(0,0,0,0.3)"
                CardBackgroundColor="white"
                CardBackground="white"
                ClassExtendCard={classes.ClassExtendCard}
            >
                <div className={classes.CardContent}>
                    <InvoiceItemsEdit
                        SaleInvoiceID={SaleInvoiceID}
                        InvoiceItemID={ViewCartPurchaseItemId}
                        CloseCard={HandleCloseEditItemCard}
                        ViewEditMode={Ref_PurchaseItemViewMode.current}
                        CustomerAccountingPreference={CustomerAccountingPreference}
                    />
                </div>
            </CardModal>
        );
    }
    if (ShowDuplicateCard === true) {
        ModalCard = (
            <CardModal
                CardID="DuplicateInvoiceCard"
                // CardID="HealFit_CreateDailyIntake"
                // ParentCompRef={Ref_TabNavContent}
                // TopBarContent={CardTitle}
                CloseCard={HandleCloseDuplicateCard}
                CloseOnClickOutside={false}
                WithCloseButton={true}
                // CardMaxWidth="800px"
                // CardHeight="700px"
                CardWindowPaddingVertical="10px"
                CardWindowPaddingHorizontal="10px"
                WithPerfectScrollbar={true}
                // CardWindowPaddingVertical="50px"

                ShowCard={true}
                WindowBackgroundColor="rgba(0,0,0,0.3)"
                CardBackgroundColor="white"
                CardBackground="white"
                ClassExtendCard={classes.ClassExtendCard}
            >
                <div className={classes.CardContent}>
                    <InvoiceDuplicate DuplicateId={DuplicateCardId} HandleCloseViewCard={HandleCloseDuplicateCard} />
                </div>
            </CardModal>
        );
    }
    let FinalTableComponent;

    if (Init === true) {
        if (TableComponent) {
            FinalTableComponent = (
                <div>
                    <div className={classes.ButtonBar}>
                        <div className={classes.ButtonLeft}>
                            <Button
                                Width="140px"
                                Height="25px"
                                style={{margin: "0px 0px", padding: "0px 5px 0px 5px", justifyContent: "space-between", display: `${FormViewMode === "View" ? "none" : null}`}}
                                onClick={HanldeCreateNewPurcahseItem}
                            >
                                <AddCircle SVGFillColor="white" IconSize="20px" />
                                Add Sale Item
                            </Button>
                        </div>
                    </div>
                    <div className={classes.TableWrapper}>{TableComponent}</div>
                </div>
            );
        } else {
            FinalTableComponent = (
                <Button
                    Width="140px"
                    Height="25px"
                    style={{margin: "0px 0px", padding: "0px 5px 0px 5px", justifyContent: "space-between", display: `${FormViewMode === "View" ? "none" : null}`}}
                    onClick={HanldeCreateNewPurcahseItem}
                >
                    <AddCircle SVGFillColor="white" IconSize="20px" />
                    Add Sale Item
                </Button>
            );
        }
    } else {
        FinalTableComponent = "There is no data";
    }

    return (
        <TabNavContent ClassExtendTabContent={classes.ClassExtendTabContent}>
            {ModalCard}
            <div className={classes.DailytButtonBar}>
                <div className={classes.FormField} style={{flex: "1 1 250px", maxWidth: "250px", width: "250px"}}></div>
            </div>
            <LocalCircularLoader Loading={Loading} WithModalCard={true} FullSize={true} />

            {FinalTableComponent}
        </TabNavContent>
    );

    /***************** RENDER ******************/
});

export default CustomerEditBankAccountTable;
